import { LoginFormData } from '../../@paco/entities/@forms/LoginForm/LoginForm'

import {
    AUTH_SAGA_AUTHENTICATE_USER,
    AUTH_SAGA_FORGOT_PASSWORD,
    AUTH_SAGA_SUBMIT_PASSWORD,
    AUTH_SAGA_UPDATE_API_TOKEN,
    AUTH_SAGA_UPDATE_REFRESH_TOKEN,
} from '../actionTypes'

const authenticateUser = (formData: LoginFormData) => ({
    type: AUTH_SAGA_AUTHENTICATE_USER,
    credentials: formData,
})

const setApiToken = (apiToken: string) => ({
    type: AUTH_SAGA_UPDATE_API_TOKEN,
    apiToken,
})

const setRefreshToken = (refreshToken: string) => ({
    type: AUTH_SAGA_UPDATE_REFRESH_TOKEN,
    refreshToken,
})

const forgotUserPassword = (email: string) => ({
    type: AUTH_SAGA_FORGOT_PASSWORD,
    email,
})

const submitUserPasswordPincode = (userId: string, password: string, pincode: string) => ({
    type: AUTH_SAGA_SUBMIT_PASSWORD,
    password,
    pincode,
    userId,
})

export {
    authenticateUser,
    forgotUserPassword,
    setApiToken,
    setRefreshToken,
    submitUserPasswordPincode,
}
